import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  BankTransferDto,
  BankTransferListDto,
  BankTransferFilterDto,
  CreateBankTransferRequest,
  UpdateBankTransferRequest,
} from '@/types/bankTransfer.types';

export const bankTransferApi = {
  /** GET /api/v1/bank-transfers — paginated list */
  getList: (filter?: BankTransferFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<BankTransferListDto>>>('/bank-transfers', { params: filter }),

  /** GET /api/v1/bank-transfers/{id} — full transfer detail */
  getById: (id: string) =>
    apiClient.get<ApiResponse<BankTransferDto>>(`/bank-transfers/${id}`),

  /** POST /api/v1/bank-transfers — create new transfer (Draft) */
  create: (data: CreateBankTransferRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/bank-transfers', data),

  /** PUT /api/v1/bank-transfers/{id} — update draft transfer */
  update: (id: string, data: UpdateBankTransferRequest) =>
    apiClient.put<ApiResponse<object>>(`/bank-transfers/${id}`, data),

  /** POST /api/v1/bank-transfers/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-transfers/${id}/submit`),

  /** POST /api/v1/bank-transfers/{id}/approve — approve the transfer */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-transfers/${id}/approve`, { remarks }),

  /** POST /api/v1/bank-transfers/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-transfers/${id}/reject`, { reason }),

  /** POST /api/v1/bank-transfers/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-transfers/${id}/post`),

  /** POST /api/v1/bank-transfers/{id}/reverse — create reversal transfer */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/bank-transfers/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/bank-transfers/{id}/cancel — cancel the transfer */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-transfers/${id}/cancel`, { reason }),

  /** DELETE /api/v1/bank-transfers/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/bank-transfers/${id}`),
};
